import React from 'react';
import LoadingSpinner from './LoadingSpinner';

const variants = {
	primary: 'bg-primary-600 hover:bg-primary-700 text-white',
	secondary: 'bg-secondary-500 hover:bg-secondary-600 text-white',
	danger: 'bg-red-600 hover:bg-red-700 text-white',
	ghost: 'bg-transparent hover:bg-gray-100 text-gray-700'
};

const sizes = {
	sm: 'px-3 py-1.5 text-sm',
	md: 'px-4 py-2',
	lg: 'px-5 py-2.5 text-lg'
};

export default function Button({ variant = 'primary', size = 'md', disabled, loading, className = '', children, ...props }) {
	return (
		<button
			className={`inline-flex items-center justify-center rounded-md shadow-sm transition ${variants[variant]} ${sizes[size]} ${
				disabled ? 'opacity-60 cursor-not-allowed' : ''
			} ${className}`}
			disabled={disabled || loading}
			{...props}
		>
			{loading && <LoadingSpinner size="sm" className="mr-2" />}
			{children}
		</button>
	);
}


